import { render, staticRenderFns } from "./ThirdPartyLogin.vue?vue&type=template&id=fb2b4a9e&scoped=true&"
import script from "./ThirdPartyLogin.vue?vue&type=script&lang=js&"
export * from "./ThirdPartyLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2b4a9e",
  null
  
)

export default component.exports